import { useContext } from "react";
import styles from "./index.module.scss";
import { GenerateContext } from "../../../hooks/GenerateContext";
import { MODEL_HAIRSTYLE } from "@utils/CONST";

const ModelHairstyle = (props) => {
    const { modelHairstyle, setModelHairstyle } = useContext(GenerateContext);

    const items = [
        {
            value: MODEL_HAIRSTYLE.SRC,
            title: "按原图",
        },
        {
            value: MODEL_HAIRSTYLE.REF,
            title: "按参考图",
        },
    ];

    return (
        <div>
            <p className={styles.titleText}>模特发型</p>
            <div className={styles.ModelExpression}>
                {items.map((item) => (
                    <div
                        key={item.value}
                        className={`${styles.Item} ${
                            modelHairstyle === item.value ? styles.Active : ""
                        }`}
                        onClick={() => setModelHairstyle(item.value)}
                    >
                        {item.title}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ModelHairstyle;
